import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { API_ROUTES } from '../../util/route.constants';
import { PatientResponse } from '../../models/patient.interface';

@Injectable({
    providedIn: 'root',
})
export class PatientService {
    constructor(private readonly http: HttpClient) { }

    getPatientById(patientId: string): Observable<{ response: PatientResponse }> {
        return this.http.get<{ response: PatientResponse }>(`${environment.cva_url}${API_ROUTES.PATIENT}/${patientId}`);
    }
}
